import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItemAuthorBasicInfo } from './trendListResponsePageAllOfThreeContentItemContentTweetsItemAuthorBasicInfo';
import type { TrendListResponsePageAllOfThreeContentItemContentTweetsItemAuthorSocial } from './trendListResponsePageAllOfThreeContentItemContentTweetsItemAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type TrendListResponsePageAllOfThreeContentItemContentTweetsItemAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: TrendListResponsePageAllOfThreeContentItemContentTweetsItemAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: TrendListResponsePageAllOfThreeContentItemContentTweetsItemAuthorSocial;
};
